import type { FaireProductEntity } from "../../entity_types/product";

export const p_9s2fenn8bp: FaireProductEntity = {
  token: "p_9s2fenn8bp",
  type: "product",
  name: "Tomato & Thyme Grass-fed Beef Bone Broth 14oz",
  brandToken: "b_3nwax652hv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1d2e3bf135da7032126d985b1337b8e8c78d059c19ad8944a9cb40174eae2db3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bde7fa22c29620a246427cc51f6e0bb11c16006e45e60f8427937e5a4edf50e.png",
    "https://cdn.faire.com/fastly/ca829d02def689fec4fefd31f9c39692e5da0950716a1725d9dc3138007b802c.png",
    "https://cdn.faire.com/fastly/db17d1b6503339b02cfbcc38fe9d127b2c3bf54b76120bc3c3c31252d795da38.png",
  ],
  priceDollars: 8.31,
  description:
    "Think of Firstade as an old favorite, reimagined. Though you can find its main ingredients at your local farmer's market or maybe even in your backyard garden, we've combined them in a way that showcases the nourishment and delight that simple ingredients can provide. And many of its ingredients offer immune-boosting benefits, making it the perfect daily sip.\n\nA note on our sourcing: we only use grass-fed and finished beef bones and organic herbs and veggies - no hormones, GMOs, added sugar, antibiotics or preservatives. From brew to jar, we also utilize a 100% plastic-free process, and all of our broths are shelf-stable!\n\nSold in packs of 4 - trust us, you’ll go through it faster than you think! \n\n\"Firstade is comfort in a cup and satisfies my craving for something savory morning, afternoon or night!\" -Natasha H.",
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:06.485Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
